import replace from "lodash/replace";
import isEmpty from "lodash/isEmpty";
export var convertToNumber = function (price) {
    if (isEmpty(price)) {
        return 0;
    }
    else {
        return Number(replace(price, /\$|,/g, ""));
    }
};
